<div class="container">
  <div class="row">
    <div class="col-3"></div>
    <mat-card class="col-6 mat-elevation-z6">
      <mat-card-header>
        <mat-card-title class="w-100 text-center">IKTVA data was submitted successfully</mat-card-title>
        <hr />
      </mat-card-header>
      <mat-card-content>
        <p>Your LCGPA Form ID is: <b>{{data.iktvaFormData?.UniqueIktvaId}}</b></p>
        <p>Confirmation email will be sent to <b>{{data.iktvaFormData?.EmailContactPerson}}</b></p>
      </mat-card-content>
    </mat-card>
  </div>
</div>
